import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import {
  background,
  boxShadow,
  green,
  purple,
  white,
} from "../../../theme/colours";

const PlayerImage = ({ type, width, styles }) => {
  const outerGradient = {
    background: `linear-gradient(135deg, ${purple[1]} 0%, ${green[1]} 100%)`,
    boxShadow: `0px 3px 6px ${boxShadow}`,
    borderRadius: "50%",
    p: "4px",
    height: "fit-content",
    display: "flex",
    ...styles,
  };

  const innerBoxStyle = {
    backgroundColor: background.primary,
    boxShadow: `0px 3px 6px ${boxShadow}`,
    borderRadius: "50%",
    width: "100%",
    p: "6px",
    display: "flex",
    height: "fit-content",
  };

  const image = {
    transition: "width 0.25s ease, height 0.25s ease",
    backgroundColor: white,
    borderRadius: "50%",
    width: width ? width : "100%",
    height: width ? width : "100%",
  };

  const [source, setSource] = useState("");

  useEffect(() => {
    if (type) {
      const typeNumber = Math.max(parseInt(type?.substring(4)), 12);
      setSource(`images/avatars/type${typeNumber || "12"}.svg`);
    }
  }, [type]);

  return (
    <Box sx={outerGradient}>
      <Box sx={innerBoxStyle}>
        <Box sx={image} component="img" src={source} alt="User Avatar" />
      </Box>
    </Box>
  );
};

export default PlayerImage;
